// src/routes/AppRouter.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import ProtectedRoute  from "./ProtectedRoute";

import Home            from "../pages/Home";
import BoneBeat        from "../pages/BoneBeat";
import BoneFrame       from "../pages/BoneFrame";
import BoneForge       from "../pages/BoneForge";
import AccountSettings from "../pages/AccountSettings";
import AdminDashboard  from "../pages/AdminDashboard";
import Terms           from "../pages/Terms";
import Privacy         from "../pages/Privacy";
import Donate          from "../pages/Donate";
import ZNotFound       from "../pages/ZNotFound";
import Profile         from "../pages/Profile";

function AuthRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user)    return <Navigate to="/" replace />;
  return <Navigate to="/" state={{ openAuth: true }} replace />;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/"        element={<Home />} />
      <Route path="/auth"    element={<AuthRoute />} />
      <Route path="/terms"   element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/donate"  element={<Donate />} />

      <Route path="/bonebeat"  element={<ProtectedRoute><BoneBeat /></ProtectedRoute>} />
      <Route path="/boneframe" element={<ProtectedRoute><BoneFrame /></ProtectedRoute>} />
      <Route path="/boneforge" element={<ProtectedRoute><BoneForge /></ProtectedRoute>} />
      <Route path="/settings"  element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />

      <Route path="/profile/:uid" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />

      <Route path="/form"  element={<Navigate to="/boneframe" replace />} />
      <Route path="/games" element={<Navigate to="/boneforge" replace />} />

      <Route path="*" element={<ZNotFound />} />
    </Routes>
  );
}
